import { Link } from "react-router-dom";
import { ArrowRight, Shield, Clock, Award, Wind, Thermometer, Zap, Droplets, Layout, FileText, Leaf, TreePine, Smartphone, TrendingUp, Check } from "lucide-react";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { BackgroundCarousel } from "../components/BackgroundCarousel";
import { QuoteForm } from "../components/QuoteForm";
import { SEO } from "../components/SEO";
import { services, heatingDesignServices, smartFeatures, maintenancePackages } from "../mockData";

const luxuryBathroomImages = [
  // #1 HERO SHOT - Most Impressive
  "https://images.unsplash.com/photo-1689917781910-ac9115b77d27?w=1920&q=85", // 🏆 Big natural boulders/rocks - WOW factor
  
  // SMOOTH NATURAL FLOW - Bali/Nature → London Luxury → Italian Showers → Commercial → Modern (No category grouping)
  "https://images.unsplash.com/photo-1743213992612-c15167c1b269?w=1920&q=85", // Ocean-view bathtub - cinematic Bali
  "https://images.unsplash.com/photo-1615580064300-7f38da8aaa97?w=1920&q=85", // British elegant bathroom - white ceramic tub
  // REMOVED: Jungle bathtub with lush plants & rocks (was 4th photo)
  // REMOVED: Italian shower broken image (line 19)
  "https://images.unsplash.com/photo-1760564019103-81cd3c225cd1?w=1920&q=85", // Freestanding outdoor tub in nature
  "https://images.unsplash.com/photo-1764551322786-54a994923d8f?w=1920&q=85", // Marble bathroom London style - sophisticated
  "https://images.unsplash.com/photo-1774876549429-97c4e83eb557?w=1920&q=85", // ✨ Italian shower - modern marble glass door
  "https://images.unsplash.com/photo-1585576207154-7a6daca0a92c?w=1920&q=85", // Ocean sunset tropical bathtub
  "https://images.unsplash.com/photo-1668150078766-552812c75ce2?w=1920&q=85", // Hotel luxury - marble bathtub elegant
  "https://images.unsplash.com/photo-1650894622580-04d8c978f8c8?w=1920&q=85", // ✨ Italian shower - shelves & bottles, modern
  "https://images.unsplash.com/photo-1694501898715-6961da5a6e67?w=1920&q=85", // Woman outdoor bathtub wooden deck sunset
  "https://images.unsplash.com/photo-1657114012245-cfa18766a58a?w=1920&q=85", // Dark marble London bathroom - freestanding tub
  "https://images.unsplash.com/photo-1765766600805-e75c44124d2c?w=1920&q=85", // ✨ Walk-in shower - marble & dark stone
  "https://images.unsplash.com/photo-1750036015902-c6f5ebca924e?w=1920&q=85", // Zen garden expansive views
  "https://images.unsplash.com/photo-1728486884112-e6e5d7ccfea5?w=1920&q=85", // Large jacuzzi spa - commercial
  "https://images.unsplash.com/photo-1771372012124-f7696f374a5a?w=1920&q=85", // ✨ Walk-in shower - freestanding tub & double vanity modern
  "https://images.unsplash.com/photo-1625578324458-a106197ff141?w=1920&q=85", // Wooden bathtub tropical plants Bali
  "https://images.unsplash.com/photo-1764475501545-d5cc9719af1a?w=1920&q=85", // Golden bathroom vanity commercial restaurant
  "https://images.unsplash.com/photo-1771929662486-f793e08f0f16?w=1920&q=85", // ✨ Italian shower - glass enclosed marble walls
  "https://images.pexels.com/photos/32426747/pexels-photo-32426747.jpeg?w=1920&q=85", // Indoor stone bath garden view
  "https://images.unsplash.com/photo-1650532897813-d92427f7d229?w=1920&q=85", // Fancy hotel bathroom suite marble
  "https://images.unsplash.com/photo-1744025098626-66c0b9cb1ba8?w=1920&q=85", // Elegant marble walls modern minimalist
  "https://images.unsplash.com/photo-1728486885790-1454260d9246?w=1920&q=85", // Spa bathroom commercial elegant
  "https://images.unsplash.com/photo-1621215058889-885f3d5a143c?w=1920&q=85", // Spacious modern luxury
  "https://images.unsplash.com/photo-1765745518752-68a289300789?w=1920&q=85", // Modern vanity commercial premium
  "https://images.unsplash.com/photo-1772567733000-76963732d556?w=1920&q=85", // Large window nature views modern
  "https://images.pexels.com/photos/8583760/pexels-photo-8583760.jpeg?w=1920&q=85", // Contemporary marble glass shower
  "https://images.unsplash.com/photo-1769253523308-f7bff35c60b1?w=1920&q=85", // Modern bamboo zen minimalist
  "https://images.unsplash.com/photo-1664760919047-29f868c8599e?w=1920&q=85", // Art deco chandelier glamorous
  "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?w=1920&q=85" // Art deco elegant
];

export const Home = () => {
  return (
    <div className="min-h-screen bg-navy-900">
      <SEO 
        title="Magic C Plumbing | Plumber & Heating Engineer in London"
        description="Magic C Plumbing – reliable plumbing and heating in London SW18 & SW19. Leak repairs, bathrooms, boilers and landlord services. Call 07398 873176."
        canonical="/"
      />

      {/* Hero Section with Background Carousel */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        <BackgroundCarousel images={luxuryBathroomImages} interval={7000} />

        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-32">
          <div className="max-w-5xl mx-auto text-center">
            <div className="inline-block mb-8">
              <span className="bg-sage-500/20 text-sage-300 px-8 py-4 rounded-full text-base font-medium backdrop-blur-md border border-sage-500/30 shadow-xl">
                Premium Plumbing & Heating Excellence
              </span>
            </div>
            
            <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold text-white leading-tight mb-10">
              Luxury Meets
              <span className="block text-sage-400 mt-3">Functionality</span>
            </h1>
            
            <p className="text-2xl md:text-3xl text-gray-200 leading-relaxed mb-14 max-w-4xl mx-auto">
              Transform your space with award-winning plumbing design, 
              cutting-edge heating systems, and sustainable solutions.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-6 justify-center mb-20">
              <a href="#quote">
                <Button size="lg" className="bg-sage-600 hover:bg-sage-700 text-white text-xl px-12 py-8 h-auto shadow-2xl hover:shadow-sage-600/50 transition-all backdrop-blur-sm">
                  Request a Personalized Quote
                  <ArrowRight className="ml-3 h-6 w-6" />
                </Button>
              </a>
              <a href="tel:07398873176">
                <Button size="lg" variant="outline" className="border-2 border-white/80 text-white hover:bg-white hover:text-navy-900 text-xl px-12 py-8 h-auto backdrop-blur-md transition-all">
                  Emergency: 07398 873176
                </Button>
              </a>
            </div>

            {/* Trust Indicators */}
            <div className="flex flex-wrap justify-center gap-16">
              <div className="flex items-center space-x-4">
                <div className="bg-sage-500/20 p-5 rounded-full backdrop-blur-md border border-sage-500/30 shadow-xl">
                  <Shield className="h-9 w-9 text-sage-400" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-white text-xl">Gas Safe</p>
                  <p className="text-base text-gray-300">Registered</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="bg-sage-500/20 p-5 rounded-full backdrop-blur-md border border-sage-500/30 shadow-xl">
                  <Award className="h-9 w-9 text-sage-400" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-white text-xl">15+ Years</p>
                  <p className="text-base text-gray-300">Excellence</p>
                </div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="bg-sage-500/20 p-5 rounded-full backdrop-blur-md border border-sage-500/30 shadow-xl">
                  <Clock className="h-9 w-9 text-sage-400" />
                </div>
                <div className="text-left">
                  <p className="font-bold text-white text-xl">24/7</p>
                  <p className="text-base text-gray-300">Available</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview - Clean Cards */}
      <section className="py-32 bg-gradient-to-b from-navy-900 to-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Our Premium Services
            </h2>
            <p className="text-2xl text-gray-300 max-w-3xl mx-auto">
              Comprehensive plumbing solutions with unmatched quality
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
            {services.slice(0, 6).map((service) => {
              const IconComponent = require("lucide-react")[service.icon];
              return (
                <Link key={service.id} to="/services">
                  <Card className="group h-full bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all duration-500 cursor-pointer overflow-hidden">
                    <div className="relative h-64 overflow-hidden">
                      <img
                        src={service.image}
                        alt={service.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-navy-900/95 via-navy-900/50 to-transparent"></div>
                      <div className="absolute bottom-6 left-6 bg-sage-500/20 p-4 rounded-xl backdrop-blur-md border border-sage-500/30 shadow-xl">
                        <IconComponent className="h-8 w-8 text-sage-300" />
                      </div>
                    </div>
                    <CardContent className="p-8">
                      <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-sage-300 transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-gray-300 leading-relaxed mb-4">
                        {service.description}
                      </p>
                      <div className="text-sage-400 font-semibold inline-flex items-center group-hover:translate-x-2 transition-transform">
                        Learn More
                        <ArrowRight className="ml-2 h-5 w-5" />
                      </div>
                    </CardContent>
                  </Card>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Heating & Plumbing Systems Design with Video */}
      <section className="py-32 bg-gray-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Heating & Plumbing Systems Design
            </h2>
            <p className="text-2xl text-gray-300 max-w-4xl mx-auto mb-16">
              Precision-engineered systems with cutting-edge 3D technical design
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {heatingDesignServices.map((service) => {
              const IconComponent = {
                Wind, Thermometer, Zap, Droplets, Layout, FileText
              }[service.icon];
              
              return (
                <Card key={service.id} className="bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all group">
                  <CardContent className="p-8">
                    <div className="bg-sage-500/20 group-hover:bg-sage-500 w-16 h-16 rounded-2xl flex items-center justify-center mb-6 transition-all">
                      <IconComponent className="h-8 w-8 text-sage-400 group-hover:text-white transition-colors" />
                    </div>
                    <h3 className="text-2xl font-bold text-white mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Smart Plumbing & Energy Efficiency with Video */}
      <section className="py-32 bg-navy-900 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-sage-500 rounded-full filter blur-3xl opacity-10"></div>
        
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Smart Plumbing & Energy Efficiency
            </h2>
            <p className="text-2xl text-gray-300 max-w-4xl mx-auto mb-16">
              Cutting-edge technology for sustainable living
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
            {smartFeatures.map((feature) => {
              const IconComponent = { Leaf, TreePine, Smartphone, TrendingUp }[feature.icon];
              
              return (
                <Card key={feature.id} className="text-center bg-white/5 backdrop-blur-md border-white/10 hover:bg-white/10 transition-all">
                  <CardContent className="p-10">
                    <div className="bg-gradient-to-br from-sage-500 to-sage-600 w-24 h-24 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                      <IconComponent className="h-12 w-12 text-white" />
                    </div>
                    <div className="text-5xl font-bold text-sage-400 mb-4">{feature.stat}</div>
                    <h3 className="text-2xl font-bold text-white mb-4">
                      {feature.title}
                    </h3>
                    <p className="text-gray-300 leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Annual Maintenance Contracts */}
      <section className="py-32 bg-gradient-to-b from-gray-900 to-navy-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-20">
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Annual Maintenance Contracts
            </h2>
            <p className="text-2xl text-gray-300 max-w-3xl mx-auto">
              Protect your investment with comprehensive care
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
            {maintenancePackages.map((pkg) => (
              <Card 
                key={pkg.id} 
                className={`relative ${
                  pkg.popular 
                    ? 'bg-gradient-to-br from-sage-500 to-sage-600 text-white shadow-2xl transform scale-105 border-4 border-sage-400' 
                    : 'bg-white/5 backdrop-blur-md border-white/10 text-white'
                }`}
              >
                {pkg.popular && (
                  <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-yellow-400 text-navy-900 px-8 py-3 rounded-full text-sm font-bold shadow-xl">
                    MOST POPULAR
                  </div>
                )}
                <CardContent className="p-10">
                  <div className="text-sm font-bold uppercase tracking-wider mb-3 opacity-90">
                    {pkg.type}
                  </div>
                  <h3 className="text-3xl font-bold mb-6">
                    {pkg.title}
                  </h3>
                  <div className="mb-8">
                    <span className="text-5xl font-bold">{pkg.price}</span>
                    {pkg.price !== "Custom Quote" && <span className="text-xl opacity-80">/year</span>}
                  </div>
                  <ul className="space-y-4 mb-10">
                    {pkg.features.map((feature, index) => (
                      <li key={`${pkg.name}-feature-${index}`} className="flex items-start space-x-3">
                        <Check className={`h-6 w-6 flex-shrink-0 mt-0.5 ${pkg.popular ? 'text-white' : 'text-sage-400'}`} />
                        <span className="text-base">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <a href="#quote">
                    <Button 
                      className={`w-full py-6 text-lg ${
                        pkg.popular 
                          ? 'bg-white text-sage-700 hover:bg-gray-100' 
                          : 'bg-sage-600 text-white hover:bg-sage-700'
                      } shadow-xl`}
                    >
                      Get Started
                    </Button>
                  </a>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Get a Free Quote Section */}
      <section id="quote" className="py-32 bg-navy-900">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <QuoteForm />
          </div>
        </div>
      </section>
    </div>
  );
};
